import {
  Dialog, DialogActions, DialogTitle,
  DialogContent, DialogContentText,
  IconButton, TextField, LinearProgress,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { ReactElement } from 'react';

interface Props {
  networkName: string;
  username: string;
  usernameError: string | ReactElement;
  isLoading: boolean;
  onBack: () => void;
  onClose: () => void;
  onChange: (username: string) => void;
  onNext: () => void;
}

export const SelectUsername = ({
  networkName, username, usernameError, isLoading,
  onBack, onClose, onChange, onNext,
}: Props) => (
  <Dialog fullWidth onClose={onClose} aria-labelledby="title" open>
    <div className="absolute right-2 top-2">
      <IconButton aria-label="close" onClick={onClose}>
        <Close />
      </IconButton>
    </div>
    <DialogTitle id="title">{`${networkName} Username`}</DialogTitle>
    <DialogContent>
      {usernameError && <div className="text-red">{usernameError}</div>}
      <DialogContentText>
        Please enter the
        {' '}
        {networkName}
        {' '}
        username
      </DialogContentText>
      <TextField
        onChange={(e) => onChange(e.target.value.replace('@', ''))}
        autoFocus
        margin="dense"
        id="username"
        label="username"
        value={username}
        fullWidth
      />
    </DialogContent>
    <DialogActions>
      <button type="button" className="btn-primary-outlined" onClick={onBack}>
        Back
      </button>
      <button
        type="button"
        className="btn-primary"
        onClick={onNext}
        disabled={!username || isLoading}
      >
        Next
      </button>
    </DialogActions>
    {isLoading && (
      <div className="w-full">
        <LinearProgress />
      </div>
    )}
  </Dialog>
);
